import type React from "react";
import { Tooltip } from "@mui/material";

interface DisabledButtonTooltipProps {
  title: React.ReactNode;
  disabled: boolean;
  children: React.ReactElement;
}

const DisabledButtonTooltip: React.FC<DisabledButtonTooltipProps> = ({
  title,
  disabled,
  children,
}) => {
  if (!disabled || !title) {
    return children;
  }

  return (
    <Tooltip title={title} arrow disableHoverListener={false} disableFocusListener={false}>
      <span>{children}</span>
    </Tooltip>
  );
};

export default DisabledButtonTooltip;
